import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { MonitoringService } from '../monitoring/monitoring.service';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  if (request.url.includes('/log-in') || request.url.includes('/refresh-token')) {
    return next(request);
  }

  const authService = inject(AuthService);
  const monitoring = inject(MonitoringService);

  const user = authService.currentUserValue;
  const token = user?.tempToken ?? user?.accessToken;

  if (token) {
    request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${token}`) });
  }

  return next(request).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return authService.refreshToken().pipe(
          switchMap((newTokens: string) => {
            const newReq = request.clone({
              headers: request.headers.set('Authorization', `Bearer ${newTokens}`),
            });
            return next(newReq);
          }),
          catchError((refreshError) => {
            monitoring.trackError(refreshError, {
              url: request.url,
              event: 'refresh_token_failed',
            });
            
            authService.logout();
            return throwError(() => refreshError);
          }),
        );
      } else {
        return throwError(() => error);
      }
    }),
  );
};
